var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { getDataURLForImage } from './fileUtils';
export class ImageThumbnail extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            imgSrc: undefined
        };
    }
    componentDidMount() {
        getDataURLForImage(this.props.srcFile).then(img => {
            this.setState({ imgSrc: img.result });
        });
    }
    render() {
        const _a = this.props, { srcFile } = _a, rest = __rest(_a, ["srcFile"]);
        return <img {...rest} src={this.state.imgSrc}/>;
    }
}
